import { cn } from '@dfh-corp-sites/ui/utils'
import BlockContent from '@sanity/block-content-to-react'
import React from 'react'

import { serializers } from './serializers'

export interface BlockContainerProps {
  content: unknown | unknown[] | null
  classname?: string
}

const BlockContainer: React.FC<BlockContainerProps> = ({ content, classname }) => {
  if (!content) {
    return null
  }

  return (
    <div className={cn('rich-text', classname)}>
      {Array.isArray(content) ? (
        content.map((desc, i) => <BlockContent blocks={desc} serializers={serializers} key={i} />)
      ) : (
        <BlockContent blocks={content} serializers={serializers} />
      )}
    </div>
  )
}

export default BlockContainer
